import {Component, 
	OnInit, 
	ElementRef, 
	ViewChild, 
	ChangeDetectionStrategy, 
	ChangeDetectorRef, 
	HostListener, 
	ViewChildren, 
    Inject} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA, MatTabChangeEvent } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { ReplaySubject, fromEvent, merge, BehaviorSubject } from 'rxjs';
//Datasource
import { SoDoKhoDataSource } from '../so-do-kho-datasource/so-do-kho.datasource';
//Service
import { SoDoKhoService } from '../so-do-kho-service/so-do-kho.service';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, QueryParamsModel, MessageType } from '../../../../../../core/_base/crud';
import { environment } from '../../../../../../../environments/environment';
//Model
import { CommonConFig } from 'app/views/pages/nfc/dung-chung/__model/common_config.model';
import { KhuVucKho } from '../so-do-kho-model/so-do-kho.model';
import { KhoModel } from '../../../kho/kho-model/kho.model';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
	selector: 'm-xem-hang-luu-kho',
	templateUrl: './xem-hang-luu-kho.component.html',
	styleUrls: ['../so-do-kho.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})

export class XemHangLuuKhoComponent implements OnInit{

    /*Config Form */
	CONFIG: CommonConFig;

	// Table fields
	dataSource: SoDoKhoDataSource;

	displayedColumns = [];
    availableColumns = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 5,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 7,
            name: 'Soluongchungtu',
            displayName: 'SL',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'Ghichulohang',
            displayName: 'Trạng thái',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'Tag',
            displayName: 'Tags',
            alwaysChecked: false,
			isShow: true
		},
    ];
	viewLoading: boolean = false;   	// Loading khi mở dialog

    @ViewChildren('focus') focus ;
	@ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
	@ViewChild('sort1', {static: true}) sort: MatSort;
	@ViewChild('trigger', {static: true}) _trigger: MatMenuTrigger;
    
    // Selection
    selectedColumns = new SelectionModel<any>(true, this.availableColumns);

    loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();

	previousIndex: number;
    fixedPoint = 2;

	itemSDK: KhuVucKho;
	itemKho: KhoModel;

	HHKhoResult: any[] = [];
	tmpHHKhoResult: any[] = [];

	rongSaver:any[] = [];
    daiSaver:any[] = [];
    caoSaver:any[] = [];

	InfoForm: FormGroup;
	HangTmp: any;
	CotTmp: any;

    constructor(
		public dialogRef: MatDialogRef<XemHangLuuKhoComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private soDoKhoService: SoDoKhoService,
		public dialog: MatDialog,
		private InfoFB: FormBuilder,
		private route: ActivatedRoute,
		private router: Router,
		private datePipe: DatePipe,
		private translate: TranslateService,
		private subheaderService: SubheaderService,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService) {
			let user = JSON.parse(localStorage.getItem("UserInfo"));
			this.dialogRef.disableClose = true;
        }
        
    /*---------------------------- LOAD DATA --------------------------------*/
	ngOnInit() {
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();

		this.itemSDK = new KhuVucKho();
		this.itemSDK.copy(this.data.khuvuc);
		this.itemSDK.currentSelectTang -= 1;

		this.itemKho = this.data.kho;
	
		for(let i = 1; i <= this.itemKho.Hang; i++)
			this.rongSaver.push(i)
		for(let i = 1; i <= this.itemKho.Cot; i++)
			this.daiSaver.push(i)
		for(let i = 1; i <= this.itemKho.Tang; i++)
			this.caoSaver.push(i)

		this.showColumnsInTable();
		this.applySelectedColumns();

		// // If the PhieuThongTinHangVeTmp changes the sort order, reset back to the first page.
		this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
		/* Data load will be triggered in two cases:
		- when a pagination event occurs => this.paginator.page
		- when a sort event occurs => this.sort.sortChange
		**/
		merge(this.sort.sortChange, this.paginator.page)
			.pipe(
				tap(() => {
					this.loadHHKhoList();
				})
			)
			.subscribe();

		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape") {
				this.back();
			}
			this.changeDetect.detectChanges();
		});

		// Init DataSource
		this.dataSource = new SoDoKhoDataSource(this.soDoKhoService);
		let queryParams = new QueryParamsModel({});

		this.dataSource.entitySubject.subscribe(res => {
			if(res != null && res != undefined){
				this.HHKhoResult = res;
				this.HHKhoResult.push({});
			}
			else{
				this.HHKhoResult = [];
			}
			
		});
		this.HangTmp = this.itemSDK.TuHang;
		this.CotTmp = this.itemSDK.TuCot;
		this.loadHHKhoList();
		this.layoutUtilsService.setUpPaginationLabels(this.paginator);
		this.createForm();
	}
	createForm(){
		/*Group Form */
		this.InfoForm = this.InfoFB.group({
			Kho: [this.itemKho.TenKho],
			Cot: [this.itemSDK.TuHang],
			Hang: [this.itemSDK.TuCot],
		});

		/*Disable các trường dữ liệu không thay đổi */
        this.InfoForm.controls["Kho"].disable();
        /*------------------------------------------------------------------*/

        this.changeDetect.detectChanges();
	}
	loadHHKhoList() {
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			this.paginator.pageIndex,
			this.paginator.pageSize
		);
		this.dataSource.loadHHVTK(queryParams);
	}
	filterConfiguration(): any {
		const filter: any = {};
		filter.IdKho = this.itemKho.Id_Kho;
		filter.cot = this.CotTmp;
		filter.hang = this.HangTmp;
		filter.tang = this.itemSDK.SoTang;
		filter.ViTri = this.getFormatVTK();
		return filter;
	}
	XemVTK(){
		this.HangTmp = this.InfoForm.controls['Cot'].value
		this.CotTmp = this.InfoForm.controls['Hang'].value
		this.loadHHKhoList();
	}
	getBackgroundColor(state: string){
		if(state == 'Đã xác nhận')
			return '#00d146';
		else if(state == 'Nhập chưa xác nhận')
			return '#d5de01'; 	
		else if(state == 'Xuất chưa xác nhận')
			return 'red';
	}
    /* -----------------------------------------------------------------------*/

    /*---------------------- HÀM HỖ TRỢ FORMAT DẠNG SỐ -----------------------*/
    ValidateChangeNumberEvent(columnName:string, item:any, event: any) {
		var count = 0;
		for(let i = 0; i < event.target.value.length; i++){
			if(event.target.value[i] == '.'){
				count += 1;
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
    formatNumber(item: string){
        if(item == '' || item == null || item == undefined)	return '';
        return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-'+ this.fixedPoint).toFixed(this.fixedPoint)
    }
    f_currency(value: string): any {
        if (value == null || value == undefined || value == '') value = '0.00';
        let nbr = Number((value.substring(0,value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
        return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1),(this.fixedPoint + 1));
    }
    f_currency_V2(value: string): any {
        if (value == null || value == undefined || value == '') return '';
        let nbr = Number((value + '').replace(/,/g, ""));
        return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	pad(str: any, max: any) {
        str = str.toString();
        return str.length < max ? this.pad("0" + str, max) : str;
	}
	getFormatVTK(){
		let vtk = this.pad(this.HangTmp,3) + '.' + this.pad(this.CotTmp,3) + '.' + this.pad(this.itemSDK.currentSelectTang + 1,2)
		return vtk;
	}
	sum_so_luong(){
		let sum = 0;
		for(let i = 0; i < this.HHKhoResult.length; i++){
			if(this.HHKhoResult[i].Soluongchungtu){
				sum += this.HHKhoResult[i].Soluongchungtu;
			}
		}
		return sum;
	}
    /* -----------------------------------------------------------------------*/
    
    /*-------------------- HÀM HỖ TRỢ FORMAT DẠNG NGÀY -----------------------*/
    getFormatDate(v: string = '') {
        if (v != '') {
            return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
        }
        return '';
    }
    f_convertDate(p_Val: any) {
        if(p_Val == null || p_Val == undefined || p_Val == '') return '';
        let a = p_Val === "" ? new Date() : new Date(p_Val);
        return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	getFirstDay_LastDay(b_firstday) {
		var date = new Date(), y = date.getFullYear(), m = date.getMonth();
		var firstDay = new Date(y, m, 1);
		var lastDay = new Date(y, m + 1, 0);
		var curent = new Date();
		return b_firstday ? this.datePipe.transform(firstDay, 'dd/MM/yyyy') : this.datePipe.transform(curent, 'dd/MM/yyyy');
	}
    /* -----------------------------------------------------------------------*/


    /*-------- CÁC HÀM HỖ TRỢ CHUYỂN CỘT VÀ HIỂN THỊ CỘT TRONG BẢNG ----------*/
	showColumnsInTable(){
        for(let i = 0; i < this.availableColumns.length; i++){
            if(this.availableColumns[i].isShow == false){
                this.selectedColumns.toggle(this.availableColumns[i]);
            }
        }
    }
    findIndexColumn(column: string){
        for( let i = 0; i < this.availableColumns.length; i++){
            if(this.availableColumns[i].name == column)
                return i;
        }
    }
    dragStarted(event: CdkDragStart, column: string) {
        this.previousIndex = this.findIndexColumn(column);
    }
    dropListDropped(event: CdkDropList, column: string) {
        if (event) {
            moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
            this.applySelectedColumns();
        }
    }
    applySelectedColumns() {
        let _selectedColumns = this.selectedColumns.selected;
        this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
        for(let i = 0; i < this.availableColumns.length; i++){
            this.selectedColumns.toggle(this.availableColumns[i]);
            for( let j = 0; j < _selectedColumns.length; j++){
                if( this.availableColumns[i].name == _selectedColumns[j].name){
                    this.selectedColumns.toggle(this.availableColumns[i]);
                    break;
                }
            }
        }
        const _applySelectedColumns: string[] = [];
        this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
        this.displayedColumns = _applySelectedColumns;
    }
	/*----------------------------------------------------------------------- */
	
	/*Đóng dialog và cập nhập lại tình trạng, trả về highlight ID nếu có*/
	back(){
		this.dialogRef.close()
	}
	/*------------------------------------------------------------- */
}